import { PropsWithChildren, useEffect } from 'react'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from 'i18n/en.json'
import it from 'i18n/it.json'
import { getLang } from 'utils/query-params'
import { DEFAULT_LANGUAGE } from 'utils/settings'
import { determineInitialLanguage, loadDynamicTranslations } from 'i18n/index'
import { USE_TRANSLATIONS } from '../config'
import { store } from 'store/index'
import { settingsActions } from 'store/settings'

export const I18nProvider = ({ children }: PropsWithChildren) => {
  const { dispatch } = store
  useEffect(() => {
    if (USE_TRANSLATIONS) {
      loadDynamicTranslations()
        .then(() => console.debug('Dynamic translations loaded successfully'))
        .catch(() => console.error('Error loading dynamic translations'))
    }
    const lang = getLang()
    const navigatorLanguage = determineInitialLanguage()
    const lng = lang || navigatorLanguage
    dispatch(settingsActions.setLang(lng))
    console.debug({ lng })
    i18n
      .use(initReactI18next)
      .init({
        resources: {
          en: {
            translation: en,
          },
          it: {
            translation: it,
          },
          es: {
            translation: {},
          },
          de: {
            translation: {},
          },
          zh: {
            translation: {},
          },
        },
        lng,
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: {
          escapeValue: false,
        },
      })
      .then(() => i18n.changeLanguage(lng))
      .catch(() => console.debug('Translations init error'))
  }, [])

  return <>{children}</>
}
